import { VisibilityOffRounded, VisibilityRounded } from '@mui/icons-material'
import { IconButton, InputAdornment, TextField, Typography } from '@mui/material'

import type React from 'react'
import type { ChangeEvent } from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  value: string
  htmlID?: string
  showError?: boolean
  errorText?: string
  label?: string
  allowShowPassword?: boolean
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  newPasswordInput?: boolean
  'data-testid'?: string
}

const PasswordInput: React.FC<Props> = ({
  value,
  showError,
  errorText,
  label = 'Password',
  htmlID = '',
  allowShowPassword = false,
  onChange = () => null,
  newPasswordInput = false,
  ...rest
}) => {
  const { t } = useTranslation()
  const [show, setShow] = useState(false)

  return (
    <TextField
      fullWidth
      label={label}
      id={htmlID}
      value={value}
      variant="outlined"
      autoComplete={newPasswordInput ? 'new-password' : 'password'}
      onChange={onChange}
      error={showError}
      helperText={errorText}
      type={show ? 'text' : 'password'}
      data-testid={rest['data-testid']}
      slotProps={{
        input: allowShowPassword
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    disableRipple
                    aria-label="toggle password visibility"
                    onClick={() => setShow((prev) => !prev)}
                    edge="end">
                    {show ? (
                      <VisibilityOffRounded color="primary" fontSize="small" />
                    ) : (
                      <VisibilityRounded color="primary" fontSize="small" />
                    )}
                    <Typography variant="body2" color="primary" ml="4px">
                      {show
                        ? t('authentication:setPassword.hide')
                        : t('authentication:setPassword.show')}
                    </Typography>
                  </IconButton>
                </InputAdornment>
              ),
            }
          : {},
      }}
    />
  )
}

export default PasswordInput
